import React, { createRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form, message, notification } from "antd";
import DocumentInfo from "components/documentInfo/DocumentInfo";
import Layout from "components/layout";
import { bindActionCreators, Dispatch } from "redux";
import { Creators as LobbyActions } from "store/lobby/lobby-duck";
import {
  IDocumentsData,
  IDocumentType,
  IEntryPermissionActive,
  IItems,
  IItemsCheckin,
  IProcessesData,
  IRegisterActiveItem,
  ISaleChannelData,
  IStepEntryPermissionStatus,
  IVehicleProfileByPlate,
  PlateFormatType,
} from "store/lobby/lobby-model";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { IUserData, MenuItemActive } from "store/user-session/user-session-model";
import { IEventsVehicleHistory } from "typings/global";
import { DrawerStatusEnum } from "typings/global.types";
import TokenService from "utils/auth/Token.service";
import { formattedDateNow } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import ButtonsTest from "./buttons-test";
import { NewRegisterButton } from "./components/newRegister";
import VehicleAction from "./components/VehicleAction";
import Drawers from "./drawers-config";
import Filter from "./filter";
import {
  OnConfirmCancelEdit,
  onConfirmDrawerInbound,
  onConfirmDrawerInboundFromCheckin,
  onConfirmDrawerOutbound,
  onConfirmDrawerViewRegister,
  onConfirmFinishVehicleAction,
  onConfirmVehicleAction,
} from "./lobby.service";
import * as S from "./styled/index.styled";
import LobbyTabs from "./tabs";

interface IPropsScreenLobby {
  isLoading?: boolean;
  isLoadingInboundActive?: boolean;
  isLoadingInboundCheckin?: boolean;
  visibleDrawerInbound?: boolean;
  visibleDrawerOutbound?: boolean;
  drawerIsLoading?: boolean;
  visibleDrawerViewRegister?: boolean;
  visibleDrawerViewMode?: DrawerStatusEnum;
  formViewOrEditModified?: boolean;
  visibleDrawerCheckinRegister?: boolean;
  visibleModalVehicleAction?: boolean;
  visibleDrawerVehicleEntryAuthorization?: boolean;
  documentType?: IDocumentType;
}

interface IDispatchProps {
  lobbyShowDrawerInbound?: () => void;
  lobbyHideDrawerInbound?: () => void;
  lobbyShowDrawerOutbound?: () => void;
  lobbyHideDrawerOutbound?: () => void;
  lobbyShowDrawerViewRegister?: () => void;
  lobbyHideDrawerViewRegister?: () => void;
  lobbyUpdateDrawerViewMode?: (...args) => void;
  lobbyUpdateFormModified?: (...args) => void;
  lobbyFetchAllActivesAsync?: (...args) => void;
  lobbyFetchItemAsync?: (...args) => void;
  lobbySaveOutboundAsync?: () => void;
  lobbySaveInboundAsync?: () => void;
  lobbySaveVehicleActionAsync?: () => void;
  lobbyUpdateInboundAsync?: () => void;
  lobbyInboundProcessesFetchAsync?: (...args) => void;
  lobbyDocumentsFetchAsync?: () => void;
  lobbyClearDocuments?: () => void;
  lobbyFetchEntryPermissionAsync?: (...args) => void;
  lobbyChangeFieldValue?: (...args) => void;
  lobbyUpdateFilterTable?: (...args) => void;
  lobbyFetchAllCheckinsAsync?: (...args) => void;
  lobbyChangeFieldValueCheckin?: (...args) => void;
  lobbyHideDrawerCheckinRegister?: () => void;
  lobbyShowDrawerCheckinRegister?: () => void;
  lobbyFetchItemCheckinAsync?: (...args) => void;
  lobbyCheckinClearDrivers?: (...args) => void;
  lobbySaleChannelActive?: (...args) => void;
  lobbyProcessActive?: (...args) => void;
  lobbyCheckinUpdateRegisterActive?: (...args) => void;
  lobbyOutboundProcessesFetchAsync?: (...args) => void;
  lobbyOutboundProcessActive?: (...args) => void;
  lobbyShowModalVehicleAction?: (...args) => void;
  lobbyHideModalVehicleAction?: (...args) => void;
  lobbySaleChannelsFetchAsync?: (...args) => void;
  lobbyFetchItemCheckinByVehiclePlateAsync?: (...args) => void;
  lobbyFetchVehicleProfileByPlateAsync?: (...args) => void;
  lobbyUpdateVehicleProfileByPlate?: (...args) => void;
  lobbyFinishVehicleRegisterAsync?: (...args) => void;
  lobbyCheckinUpdateRegisterByVehiclePlateActive?: (...args) => void;
  lobbyFetchItemVehicleEntryAuthorizationAsync?: (...args) => void;
  lobbyShowDrawerVehicleEntryAuthorization?: (...args) => void;
  lobbyHideDrawerVehicleEntryAuthorization?: (...args) => void;
  lobbyUpdateVehicleEntryAuthorizationRegisterActive?: (...args) => void;
  userSessionMenuItemActive?: (...args) => void;
  lobbyUpdateStepEntryPermissionStatus?: (...args) => void;
  lobbyUpdateEntryPermissionActive?: (...args) => void;
  vehicleEntryAuthorizationRegisterActive?: Array<IEventsVehicleHistory>;
  documentsList?: Array<IDocumentsData>;
  userData?: IUserData;
  salesChannelList?: Array<ISaleChannelData>;
  inboundProcessesList?: Array<IProcessesData>;
  outboundProcessesList?: Array<IProcessesData>;
  hasSaleChannel?: boolean;
  hasEntryPermission?: boolean;
  disabledButton?: boolean;
  disabledButtonSaveVehicle?: boolean;
  isConcierge?: boolean;
  totalItems?: number;
  items?: Array<IItems>;
  pageIndex?: number;
  searchFilter?: string;
  itemsCheckins?: Array<IItemsCheckin>;
  totalItemsCheckins?: number;
  pageIndexCheckin?: number;
  hasCheckin?: boolean;
  allowRequestDockEntryAction?: boolean;
  allowRequestVehicleInboundAction?: boolean;
  checkinRegisterActive?: IRegisterActiveItem;
  processActive?: number;
  saleChannelActive?: number;
  outboundProcessActive?: number;
  checkinRegisterExisting?: IRegisterActiveItem;
  vehicleProfileByPlate?: IVehicleProfileByPlate | null;
  registerActive?: IRegisterActiveItem;
  stepEntryPermissionStatus?: IStepEntryPermissionStatus;
  isLoadingEntryPermission?: boolean;
  entryPermissionActive?: IEntryPermissionActive;
  plateFormatType?: PlateFormatType;
}

type IProps = IPropsScreenLobby & IDispatchProps;

const LobbyGrid = ({
  isLoading,
  drawerIsLoading,
  userData,
  items,
  totalItems,
  pageIndex,
  isConcierge,
  hasSaleChannel,
  visibleDrawerInbound,
  visibleDrawerOutbound,
  visibleDrawerViewMode,
  visibleDrawerViewRegister,
  visibleDrawerCheckinRegister,
  visibleModalVehicleAction,
  formViewOrEditModified,
  disabledButton,
  disabledButtonSaveVehicle,
  documentsList,
  searchFilter,
  itemsCheckins,
  totalItemsCheckins,
  pageIndexCheckin,
  hasCheckin,
  allowRequestDockEntryAction,
  allowRequestVehicleInboundAction,
  checkinRegisterActive,
  processActive,
  saleChannelActive,
  outboundProcessActive,
  inboundProcessesList,
  outboundProcessesList,
  salesChannelList,
  checkinRegisterExisting,
  vehicleProfileByPlate,
  visibleDrawerVehicleEntryAuthorization,
  vehicleEntryAuthorizationRegisterActive,
  isLoadingInboundActive,
  isLoadingInboundCheckin,
  registerActive,
  documentType,
  hasEntryPermission,
  stepEntryPermissionStatus,
  isLoadingEntryPermission,
  entryPermissionActive,
  plateFormatType,
  lobbySaleChannelActive,
  lobbyFetchAllActivesAsync,
  lobbyFetchItemAsync,
  lobbyFetchEntryPermissionAsync,
  lobbySaleChannelsFetchAsync,
  lobbySaveInboundAsync,
  lobbySaveVehicleActionAsync,
  lobbyShowDrawerOutbound,
  lobbyHideDrawerOutbound,
  lobbySaveOutboundAsync,
  lobbyShowDrawerInbound,
  lobbyHideDrawerInbound,
  lobbyShowModalVehicleAction,
  lobbyHideModalVehicleAction,
  lobbyUpdateInboundAsync,
  lobbyShowDrawerViewRegister,
  lobbyHideDrawerViewRegister,
  lobbyUpdateDrawerViewMode,
  lobbyUpdateFormModified,
  lobbyDocumentsFetchAsync,
  lobbyClearDocuments,
  lobbyInboundProcessesFetchAsync,
  lobbyChangeFieldValue,
  lobbyUpdateFilterTable,
  lobbyFetchAllCheckinsAsync,
  lobbyChangeFieldValueCheckin,
  lobbyHideDrawerCheckinRegister,
  lobbyShowDrawerCheckinRegister,
  lobbyFetchItemCheckinAsync,
  lobbyCheckinClearDrivers,
  lobbyProcessActive,
  lobbyCheckinUpdateRegisterActive,
  lobbyOutboundProcessesFetchAsync,
  lobbyOutboundProcessActive,
  lobbyFetchItemCheckinByVehiclePlateAsync,
  lobbyFetchVehicleProfileByPlateAsync,
  lobbyUpdateVehicleProfileByPlate,
  lobbyCheckinUpdateRegisterByVehiclePlateActive,
  lobbyFetchItemVehicleEntryAuthorizationAsync,
  lobbyShowDrawerVehicleEntryAuthorization,
  lobbyHideDrawerVehicleEntryAuthorization,
  lobbyUpdateVehicleEntryAuthorizationRegisterActive,
  lobbyUpdateStepEntryPermissionStatus,
  lobbyFinishVehicleRegisterAsync,
  userSessionMenuItemActive,
  lobbyUpdateEntryPermissionActive,
}: IProps) => {
  const tokenService = new TokenService();
  const [form] = Form.useForm();
  const [formOutbound] = Form.useForm();
  const [formView] = Form.useForm();
  const [formCheckin] = Form.useForm();
  const [formVehicleAction] = Form.useForm();
  const [yardItemId, setYardItemId] = useState(null);
  const [gateEventId, setGateEventId] = useState(null);
  const [activeTab, setActiveTab] = useState("2");
  const [vehicleActionSelected, setVehicleActionSelected] = useState(1);
  const [isLoadingLobby, setIsLoadingLobby] = useState(true);
  const carrierRef = createRef<HTMLDivElement>();
  const eventTime = formattedDateNow();
  const INTERVAL_MINUTES = 60000;
  const TITLE_PAGE = useTranslation({ id: "lobby" });
  const YES_MESSAGE = useTranslation({ id: "yes" });
  const NO_MESSAGE = useTranslation({ id: "no" });
  const FILL_IN_THE_FIELDS_CORRECTLY_MESSAGE = useTranslation({ id: "fill_in_the_fields_correctly" });
  const VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE = useTranslation({ id: "validate_duplicate_documents" });
  const REQUIRED_FIELDS_MESSAGE = useTranslation({ id: "required_fields_are_required" });
  const FINISH_VEHICLE_ERROR_MESSAGE = useTranslation({ id: "finish_vehicle_error_message" });
  const checkIfHasSaleChannelIsActive = hasSaleChannel ? saleChannelActive : null;

  const intervalCallApi = () => {
    lobbyFetchAllActivesAsync();
    lobbyFetchAllCheckinsAsync();
  };
  const visibleFocus = () => visibleDrawerInbound && carrierRef.current.focus();

  useEffect(() => {
    userSessionMenuItemActive(MenuItemActive.LOBBY);
    tokenService.authenticateToken();
  }, []);

  useEffect(() => {
    intervalCallApi();
    lobbyInboundProcessesFetchAsync();
    lobbyOutboundProcessesFetchAsync();
    lobbySaleChannelsFetchAsync();
    const timer = setInterval(() => intervalCallApi(), INTERVAL_MINUTES);
    return () => {
      clearInterval(timer);
      notification.destroy();
    };
  }, []);

  useEffect(() => {
    if (!isLoadingInboundActive && !isLoadingInboundCheckin) {
      setIsLoadingLobby(false);
    } else {
      setIsLoadingLobby(true);
    }
  }, [isLoadingInboundActive, isLoadingInboundCheckin]);

  useEffect(() => {
    return () => {
      lobbyUpdateFilterTable(null);
    };
  }, []);
  useEffect(() => {
    if (!visibleDrawerVehicleEntryAuthorization) {
      lobbyUpdateVehicleEntryAuthorizationRegisterActive([]);
    }
  }, [visibleDrawerVehicleEntryAuthorization]);

  const handleClickOutBound = ({ id }) => {
    lobbyFetchItemAsync(id);
    lobbyShowDrawerOutbound();
    setYardItemId(id);
  };
  const handleClickView = ({ id }) => {
    lobbyFetchItemAsync(id);
    lobbyShowDrawerViewRegister();
  };
  const handleClickCheckin = ({ id }) => {
    lobbyFetchItemCheckinAsync(id);
    lobbyShowDrawerCheckinRegister();
  };

  const handleClickViewDocument = ({ documents, vehiclePlate }) => {
    return <DocumentInfo documents={documents} vehiclePlate={vehiclePlate} />;
  };

  const handleClickVehicleAction = ({ gateEventId }) => {
    lobbyShowModalVehicleAction();
    setGateEventId(gateEventId);
    formVehicleAction.setFieldsValue({ dock: "" });
    setVehicleActionSelected(1);
  };

  const handleTableChange = (pagination) => {
    lobbyChangeFieldValue("itemsByPage", pagination.pageSize);
    lobbyChangeFieldValue("pageIndex", pagination.current);
    intervalCallApi();
  };
  const handleTableCheckinChange = (pagination) => {
    lobbyChangeFieldValueCheckin("itemsByPage", pagination.pageSize);
    lobbyChangeFieldValueCheckin("pageIndex", pagination.current);
    intervalCallApi();
  };

  const handleClickVehicleEntryAuthorization = ({ id }) => {
    lobbyShowDrawerVehicleEntryAuthorization();
    lobbyFetchItemVehicleEntryAuthorizationAsync({ id });
  };

  const onChangeRadioVehicleAction = (e) => {
    setVehicleActionSelected(e.target.value);
  };

  const handleOnConfirmDrawerInbound = () =>
    onConfirmDrawerInbound({
      form,
      eventTime,
      userData,
      lobbySaveInboundAsync,
      message,
      messageDescription: REQUIRED_FIELDS_MESSAGE,
      messageErrorDuplicateDocuments: VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE,
      documents: documentsList,
      inboundProcessesList,
      saleChannelActive,
      salesChannelList,
      processActive,
    });

  const handleOnConfirmDrawerOutbound = () =>
    onConfirmDrawerOutbound({
      form: formOutbound,
      outboundProcessesList,
      outboundProcessActive,
      eventTime,
      yardItemId,
      documents: documentsList,
      lobbySaveOutboundAsync,
      message,
      messageDescription: FILL_IN_THE_FIELDS_CORRECTLY_MESSAGE,
      messageErrorDuplicateDocuments: VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE,
    });

  const handleOnConfirmDrawerViewRegister = () =>
    onConfirmDrawerViewRegister({
      lobbyClearDocuments,
      visibleDrawerViewMode,
      lobbyUpdateDrawerViewMode,
      form: formView,
      lobbyUpdateInboundAsync,
      message,
      messageDescription: FILL_IN_THE_FIELDS_CORRECTLY_MESSAGE,
      messageErrorDuplicateDocuments: VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE,
      documents: documentsList,
      inboundProcessesList,
      userData,
      processActive,
      saleChannelActive: checkIfHasSaleChannelIsActive,
      salesChannelList,
    });

  const handleOnConfirmDrawerInboundFromCheckin = () =>
    onConfirmDrawerInboundFromCheckin({
      form: formCheckin,
      eventTime,
      userData,
      lobbySaveInboundAsync,
      message,
      messageDescription: REQUIRED_FIELDS_MESSAGE,
      messageErrorDuplicateDocuments: VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE,
      documents: documentsList,
      checkinRegisterActive,
      inboundProcessesList,
      processActive,
      saleChannelActive: checkIfHasSaleChannelIsActive,
      salesChannelList,
    });

  const handleClickConfirmVehicleAction = () => {
    onConfirmVehicleAction({
      form: formVehicleAction,
      id: gateEventId,
      message,
      messageDescription: REQUIRED_FIELDS_MESSAGE,
      vehicleActionSelected,
      lobbySaveVehicleActionAsync,
    });
  };

  const handleOnConfirmFinishVehicle = () => {
    onConfirmFinishVehicleAction({
      registerActive,
      message,
      messageDescription: FINISH_VEHICLE_ERROR_MESSAGE,
      lobbyFinishVehicleRegisterAsync,
    });
  };

  const handleCloseDrawerCheckinRegister = () => {
    lobbyHideDrawerCheckinRegister();
    formCheckin.resetFields();
    lobbyCheckinUpdateRegisterActive({ checkinRegisterActive: null, saleChannelDescription: null });
    lobbyCheckinClearDrivers();
    lobbyClearDocuments();
  };

  const handleCloseDrawerOutboundRegister = () => {
    lobbyHideDrawerOutbound();
    formOutbound.resetFields();
    lobbyClearDocuments();
  };

  const handleCloseDrawerViewRegister = () => {
    lobbyHideDrawerViewRegister();
    formView.resetFields();
    lobbyClearDocuments();
    lobbyUpdateDrawerViewMode(DrawerStatusEnum.View);
    lobbyUpdateFormModified(false);
  };

  const handleCloseDrawerInbound = () => {
    lobbyHideDrawerInbound();
    form.resetFields();
    lobbyClearDocuments();
    lobbyCheckinUpdateRegisterByVehiclePlateActive(null);
  };

  return (
    <Layout title={TITLE_PAGE} isLoading={isLoading} role={userData.role}>
      <S.LobbyContainer>
        <S.HeaderContainer>
          {!isConcierge && <div></div>}
          <NewRegisterButton isConcierge={isConcierge} lobbyShowDrawerInbound={lobbyShowDrawerInbound} />
          <Filter lobbyUpdateFilterTable={lobbyUpdateFilterTable} />
        </S.HeaderContainer>
        <LobbyTabs
          hasCheckin={hasCheckin}
          allowRequestDockEntryAction={allowRequestDockEntryAction}
          allowRequestVehicleInboundAction={allowRequestVehicleInboundAction}
          totalItemsCheckins={totalItemsCheckins}
          itemsCheckins={itemsCheckins}
          pageIndexCheckin={pageIndexCheckin}
          searchFilter={searchFilter}
          totalItems={totalItems}
          items={items}
          pageIndex={pageIndex}
          isConcierge={isConcierge}
          handleTableCheckinChange={handleTableCheckinChange}
          intervalCallApi={intervalCallApi}
          lobbyChangeFieldValueCheckin={lobbyChangeFieldValueCheckin}
          lobbyUpdateFilterTable={lobbyUpdateFilterTable}
          handleClickOutBound={handleClickOutBound}
          handleClickView={handleClickView}
          handleClickCheckin={handleClickCheckin}
          handleClickVehicleAction={handleClickVehicleAction}
          handleTableChange={handleTableChange}
          handleClickVehicleEntryAuthorization={handleClickVehicleEntryAuthorization}
          handleClickViewDocument={handleClickViewDocument}
          lobbyChangeFieldValue={lobbyChangeFieldValue}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          userData={userData}
          isLoadingLobby={isLoadingLobby}
        />
        <Drawers
          isConcierge={isConcierge}
          visibleDrawerInbound={visibleDrawerInbound}
          visibleDrawerOutbound={visibleDrawerOutbound}
          visibleDrawerViewMode={visibleDrawerViewMode}
          visibleDrawerViewRegister={visibleDrawerViewRegister}
          visibleDrawerVehicleEntryAuthorization={visibleDrawerVehicleEntryAuthorization}
          formViewOrEditModified={formViewOrEditModified}
          disabledButton={disabledButton}
          documentsList={documentsList}
          inboundProcessesList={inboundProcessesList}
          outboundProcessesList={outboundProcessesList}
          form={form}
          carrierRef={carrierRef}
          YES_MESSAGE={YES_MESSAGE}
          NO_MESSAGE={NO_MESSAGE}
          formOutbound={formOutbound}
          formView={formView}
          formCheckin={formCheckin}
          visibleFocus={visibleFocus}
          lobbyHideDrawerOutbound={handleCloseDrawerOutboundRegister}
          lobbyHideDrawerInbound={handleCloseDrawerInbound}
          lobbyHideDrawerViewRegister={handleCloseDrawerViewRegister}
          lobbyHideDrawerVehicleEntryAuthorization={lobbyHideDrawerVehicleEntryAuthorization}
          lobbyDocumentsFetchAsync={lobbyDocumentsFetchAsync}
          handleOnConfirmDrawerInbound={handleOnConfirmDrawerInbound}
          handleOnConfirmDrawerOutbound={handleOnConfirmDrawerOutbound}
          handleOnConfirmDrawerViewRegister={handleOnConfirmDrawerViewRegister}
          visibleDrawerCheckinRegister={visibleDrawerCheckinRegister}
          handleOnConfirmDrawerInboundFromCheckin={handleOnConfirmDrawerInboundFromCheckin}
          lobbyHideDrawerCheckinRegister={handleCloseDrawerCheckinRegister}
          lobbyProcessActive={lobbyProcessActive}
          lobbyOutboundProcessActive={lobbyOutboundProcessActive}
          hasSaleChannel={hasSaleChannel}
          lobbySaleChannelActive={lobbySaleChannelActive}
          salesChannelList={salesChannelList}
          checkinRegisterExisting={checkinRegisterExisting}
          vehicleProfileByPlate={vehicleProfileByPlate}
          lobbyFetchItemCheckinByVehiclePlateAsync={lobbyFetchItemCheckinByVehiclePlateAsync}
          lobbyFetchVehicleProfileByPlateAsync={lobbyFetchVehicleProfileByPlateAsync}
          lobbyUpdateVehicleProfileByPlate={lobbyUpdateVehicleProfileByPlate}
          vehicleEntryAuthorizationRegisterActive={vehicleEntryAuthorizationRegisterActive}
          lobbyUpdateFormModified={lobbyUpdateFormModified}
          userData={userData}
          handleOnConfirmFinishVehicle={handleOnConfirmFinishVehicle}
          drawerIsLoading={drawerIsLoading}
          documentType={documentType}
          hasEntryPermission={hasEntryPermission}
          stepEntryPermissionStatus={stepEntryPermissionStatus}
          lobbyFetchEntryPermissionAsync={lobbyFetchEntryPermissionAsync}
          isLoadingEntryPermission={isLoadingEntryPermission}
          entryPermissionActive={entryPermissionActive}
          lobbyUpdateStepEntryPermissionStatus={lobbyUpdateStepEntryPermissionStatus}
          lobbyUpdateEntryPermissionActive={lobbyUpdateEntryPermissionActive}
          saleChannelActive={saleChannelActive}
          plateFormatType={plateFormatType}
          processActive={processActive}
        />
        <VehicleAction
          activeTab={activeTab}
          formVehicleAction={formVehicleAction}
          vehicleActionSelected={vehicleActionSelected}
          allowRequestDockEntryAction={allowRequestDockEntryAction}
          allowRequestVehicleInboundAction={allowRequestVehicleInboundAction}
          visibleModalVehicleAction={visibleModalVehicleAction}
          setVehicleActionSelected={setVehicleActionSelected}
          onChangeRadioVehicleAction={onChangeRadioVehicleAction}
          handleClickConfirmVehicleAction={handleClickConfirmVehicleAction}
          lobbyHideModalVehicleAction={lobbyHideModalVehicleAction}
          disabledButtonSaveVehicle={disabledButtonSaveVehicle}
        />
        <ButtonsTest
          handleOnConfirmDrawerOutbound={handleOnConfirmDrawerOutbound}
          handleOnConfirmDrawerInbound={handleOnConfirmDrawerInbound}
          handleOnConfirmDrawerViewRegister={handleOnConfirmDrawerViewRegister}
          OnConfirmCancelEdit={OnConfirmCancelEdit}
          handleOnConfirmDrawerInboundFromCheckin={handleOnConfirmDrawerInboundFromCheckin}
          handleOnConfirmFinishVehicle={handleOnConfirmFinishVehicle}
        />
      </S.LobbyContainer>
    </Layout>
  );
};

const mapDispatchToActions = (dispatch: Dispatch) => bindActionCreators({ ...LobbyActions, ...UserSessionActions }, dispatch);

const mapStateToProps = (state) => ({
  isLoading: state.Lobby.isLoading,
  userData: state.UserSession.userData,
  items: state.Lobby.items,
  totalItems: state.Lobby.totalItems,
  pageIndex: state.Lobby.filterActive.pageIndex,
  disabledButton: state.Lobby.disabledButton,
  disabledButtonSaveVehicle: state.Lobby.disabledButtonSaveVehicle,
  isConcierge: state.UserSession.isConcierge,
  documentsList: state.Lobby.documentsList,
  visibleDrawerInbound: state.Lobby.visibleDrawerInbound,
  visibleDrawerOutbound: state.Lobby.visibleDrawerOutbound,
  visibleDrawerViewRegister: state.Lobby.visibleDrawerViewRegister,
  visibleDrawerViewMode: state.Lobby.visibleDrawerViewMode,
  visibleModalVehicleAction: state.Lobby.visibleModalVehicleAction,
  formViewOrEditModified: state.Lobby.formViewOrEditModified,
  searchFilter: state.Lobby.searchFilter,
  itemsCheckins: state.Lobby.itemsCheckins,
  totalItemsCheckins: state.Lobby.totalItemsCheckins,
  pageIndexCheckin: state.Lobby.filterCheckin.pageIndex,
  hasCheckin: state.Lobby.hasCheckin,
  hasSaleChannel: state.Lobby.hasSaleChannel,
  documentType: state.Lobby.documentType,
  visibleDrawerCheckinRegister: state.Lobby.visibleDrawerCheckinRegister,
  checkinRegisterActive: state.Lobby.checkinRegisterActive,
  processActive: state.Lobby.processActive,
  saleChannelActive: state.Lobby.saleChannelActive,
  salesChannelList: state.Lobby.salesChannelList,
  inboundProcessesList: state.Lobby.inboundProcessesList,
  outboundProcessesList: state.Lobby.outboundProcessesList,
  outboundProcessActive: state.Lobby.outboundProcessActive,
  allowRequestDockEntryAction: state.Lobby.allowRequestDockEntryAction,
  allowRequestVehicleInboundAction: state.Lobby.allowRequestVehicleInboundAction,
  checkinRegisterExisting: state.Lobby.checkinRegisterExisting,
  vehicleProfileByPlate: state.Lobby.vehicleProfileByPlate,
  visibleDrawerVehicleEntryAuthorization: state.Lobby.visibleDrawerVehicleEntryAuthorization,
  vehicleEntryAuthorizationRegisterActive: state.Lobby.vehicleEntryAuthorizationRegisterActive,
  isLoadingInboundActive: state.Lobby.isLoadingInboundActive,
  isLoadingInboundCheckin: state.Lobby.isLoadingInboundCheckin,
  registerActive: state.Lobby.registerActive,
  drawerIsLoading: state.Lobby.drawerIsLoading,
  hasEntryPermission: state.Lobby.hasEntryPermission,
  stepEntryPermissionStatus: state.Lobby.stepEntryPermissionStatus,
  isLoadingEntryPermission: state.Lobby.isLoadingEntryPermission,
  entryPermissionActive: state.Lobby.entryPermissionActive,
  plateFormatType: state.Lobby.plateFormatType,
});

export default connect(mapStateToProps, mapDispatchToActions)(LobbyGrid);
